// Clase para Firma de certificado Evicertia

import * as React from 'react';
import moment from 'moment';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import BtnPrincipal from 'src/components/Buttons/BtnPrincipal';
import { DIV } from 'src/components/CustomStyledComponents';
import FooterButton from 'src/components/FooterBtn/FooterButton';
import HeaderPage from 'src/components/header/HeaderPage';
import NavbarHeader from 'src/components/header/NavbarHeader';
import InfoCompra from 'src/components/InfoCompra';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import withCotizacion from 'src/HOC/withCotizacion';
import useCustomToast from 'src/hooks/useCustomToast';
import useLoading from 'src/hooks/useLoading';
import usePageValidation from 'src/hooks/usePageValidation';
import { firmarDocumentosEV, guardarLead, guardarLeadPoliza, POST } from 'src/services';
import { enviarCorreoEvicertia, urlBeforeSavePoliza } from 'src/services/urls';

const TAG = 'firmarCertificado';

const FirmarCertificado = ({ cotizacion, idCotizacion }) => {
  const { values, setLoading, resetLoading, setSecundario } = useLoading();
  const history = useHistory();

  const { addWarningToast, addSuccessToast } = useCustomToast();
  const { execEvent, isLoadingCallbacks } = usePageValidation('firmarCertificado');

  const init = React.useCallback(() => {
    execEvent('initCallback', {});
    beforeSave();
  }, [isLoadingCallbacks, execEvent]);

  const beforeSave = async () => {
    setLoading(true);
    const resBeforeSave = await POST(urlBeforeSavePoliza(idCotizacion));
    resetLoading();
    console.log('BEFORE SAVE: ', resBeforeSave);
  };

  const onClickFirmar = async (event) => {
    if (`${cotizacion?.producto?.enviaCorreoFirma}` === '1') {
      setLoading(true);
      const { data } = await axios.post(enviarCorreoEvicertia(), { idCotizacion });
      if (data.transaccion) {
        addSuccessToast('Se ha enviado un correo de confirmación a tu correo');
      } else {
        addWarningToast(
          data.errorDescripcion || 'No se ha podido enviar el correo de confirmación',
        );
      }
      resetLoading();
      return;
    }
    execEvent('onClickFirmar', {}, async () => {
      guardarLead(idCotizacion, `FIRMAR_EV__CLICK_FIRMAR_POLIZA`);
      setLoading(true);
      guardarLeadPoliza(idCotizacion, 'INGRESAR_FIRMA__SOLICITO_FIRMA');
      setSecundario('Estamos procesando tu petición, pronto serás redireccionado');

      // "20-04-2023 02:57:42
      const body = {
        idCotizacion: cotizacion.idCotizacion,
        firFechaHora: moment().format('DD-MM-YYYY HH:mm:ss')
      };

      const { data } = await firmarDocumentosEV(body);

      if (data?.transaccion) {
        return (window.location.href = data.urlFirma);
      }
      addWarningToast(data.errorDescripcion || 'Ha ocurrido un problema al generar los documentos');
      resetLoading();
    });
  };

  React.useEffect(() => {
    //::se agrega redirección en caso que el producto no tenga firma
    if (`${cotizacion.producto.tieneFirma}` === '0') {
      return history.push(`/paginaResumen/${idCotizacion}`)
    } else {
      guardarLead(idCotizacion, `FIRMAR_EV__INGRESO`);
      init();
    }

  }, []);

  const periocidadPago = cotizacion?.producto?.periocidadPago;
  return (
    <LoadingWrapper {...values}>
      <DIV stylePath="firmarPolizaEv.globalStyles" className="container-fluid container-page">
        <NavbarHeader showBack={false} />
        <HeaderPage progreso={90} />

        <div className="row justify-content-center">
          <div className="col-11 col-md-6 mt-3">
            <h4 className="titulo font-weight-bold">Firma de certificado</h4>
            <p className="descripcion">
              A continuación realiza la firma electrónica de tu certificado.
            </p>
          </div>
        </div>

        <div className="row justify-content-center" style={{ marginBottom: "1rem" }}>
          <InfoCompra
            total={cotizacion.valoresPagar.total}
            periocidadPago={` Pago ${periocidadPago === 'Indefinido' ? 'Recurrente' : periocidadPago
              } `}
          />

          <div>
            <div className="row justify-content-center text-center">
              <div className="mensajes col-10 col-sm-12 mt-5">
                <p className="mensaje__uno">Estas a solo un paso de finalizar tu compra.</p>
              </div>
            </div>
            {cotizacion.formPagoSeleccionada === 'PTP' && (
              <div className="row justify-content-center">
                <div className="col-xs-3 text-center ">
                  <BtnPrincipal
                    label="Mis pagos"
                    onClick={() =>
                      history.push(`/listado-pago/${idCotizacion}/${cotizacion.empPtp}`)
                    }
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <FooterButton
          label={
            `${cotizacion?.producto?.enviaCorreoFirma}` === '1'
              ? 'Enviar correo para firma'
              : 'Ver y firmar certificado'
          }
          onClick={onClickFirmar}
        />
      </DIV>
    </LoadingWrapper>
  );
};


export default withCotizacion(FirmarCertificado);
